import { render, staticRenderFns } from "./infomation.vue?vue&type=template&id=651eec38&"
import script from "./infomation.vue?vue&type=script&lang=js&"
export * from "./infomation.vue?vue&type=script&lang=js&"
import style0 from "./infomation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports